import React from 'react';

const IconClose = props =>
  <svg viewBox="0 0 22 22" width="22px" height="22px" {...props}>
    <path d="M10.004 7.409l-1.41-1.411L5.002 9.589L1.411 5.998L0 7.409L3.591 11L0 14.592l1.411 1.411l3.591-3.592 l3.592 3.592l1.41-1.411L6.413 11L10.004 7.409z" />
  </svg>;

export default IconClose;
